"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createImgErrorHandler = exports.onImgError = exports.getRouteMeta = exports.getVRef = exports.registerComponentsVite = exports.registerComponents = void 0;
const tslib_1 = require("tslib");
const camelCase_1 = tslib_1.__importDefault(require("lodash/camelCase"));
const upperFirst_1 = tslib_1.__importDefault(require("lodash/upperFirst"));
const isFunction_1 = tslib_1.__importDefault(require("lodash/isFunction"));
const consts_1 = require("./consts");
/**
 * @example
 * registerComponents(
 *    require.context(
 *      './components', true, // is deep
 *      /[A-Z]\w+\.(vue|js|ts)$/
 *    ), Vue
 * )
 *
 * @param context - Require context
 * @param Vue - Vue instance
 */
const registerComponents = (context, Vue) => {
    context.keys().forEach((filename) => {
        const component = context(filename).default || context(filename);
        const componentName = !(0, isFunction_1.default)(component)
            ? component.name
            : (0, upperFirst_1.default)((0, camelCase_1.default)(filename
                .replace(/^\.\/(.*)\.\w+$/, '$1')
                .split('/')
                .pop()));
        Vue.component(componentName, component);
    });
};
exports.registerComponents = registerComponents;
/**
 * @example
 * await registerComponentsVite(
 *    Vue,
 *    import.meta.glob('./components/base/*.vue'),
 *    import.meta.glob('./components/custom/*.vue')
 * )
 *
 * @param Vue - Vue instance
 * @param modules - import.meta.glob
 */
const registerComponentsVite = (Vue, ...modules) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    let i = 0;
    for (const mods of modules) {
        for (const pathName in mods) {
            const mod = yield mods[pathName]();
            const componentName = pathName
                .replace(/^\.\/(.*)\.\w+$/, '$1')
                .split('/')
                .pop();
            Vue.component(componentName || `component-${i}`, mod.default || mod);
            i += 1;
        }
    }
});
exports.registerComponentsVite = registerComponentsVite;
const getVRef = (ref) => {
    if (!ref)
        return [undefined, undefined];
    const eRef = Array.isArray(ref) ? ref[0] : ref;
    if (ref instanceof Element)
        return [ref, undefined];
    return [eRef.$el, eRef];
};
exports.getVRef = getVRef;
const getRouteMeta = (route, key) => {
    const matchedRoute = route.matched.find((route) => {
        return Object.prototype.hasOwnProperty.call(route.meta, key);
    });
    return matchedRoute ? matchedRoute.meta[key] : null;
};
exports.getRouteMeta = getRouteMeta;
const onVImgError = (config) => {
    // Initialize config
    const { ref, index = 0, size = '512x512' } = config;
    // Extracting image reference
    const eRef = Array.isArray(ref) ? ref[index] : ref;
    if (!eRef)
        return;
    // Extracting image element
    const el = eRef instanceof Element ? eRef : eRef.$el;
    if (el instanceof HTMLImageElement) {
        // Set image source
        el.src = `${config.base || consts_1.VIA_PLACEHOLDER}${size}`;
    }
    // finding the actual image element
    const img = el.querySelector('.v-image__image');
    if (!img)
        return;
    img.classList.remove(`v-image__image--preload`);
    img.style.backgroundImage = `url(${config.base || consts_1.VIA_PLACEHOLDER}${size})`;
};
const onImgError = (config) => {
    if (config.ref)
        return onVImgError({
            ref: config.ref,
            index: config.index,
            size: config.size,
            base: config.base,
        });
    // Initialize config
    const { $event, size = '512x512' } = config;
    // if no image reference, return
    if (!$event || !$event.target)
        return;
    // replacing the image with placeholder
    const target = $event.target;
    target.src = `${config.base || consts_1.VIA_PLACEHOLDER}${size}`;
};
exports.onImgError = onImgError;
const createImgErrorHandler = ({ base = consts_1.VIA_PLACEHOLDER, }) => {
    return (config) => {
        return (0, exports.onImgError)(Object.assign(Object.assign({}, config), { base }));
    };
};
exports.createImgErrorHandler = createImgErrorHandler;
